/* eslint-disable @angular-eslint/component-selector */
import { CurrencyPipe, DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  DisplayLabelPipe,
  OrderExecTypePipe,
  OrderIsPartiallyFilledPipe,
  OrderIsStornoPipe,
  OrderIsStornoPipe as OrderIsStornoPipe_1,
  OrderStatusPipe,
  ShorthandSymbolPipe,
} from '@zero/shared/ui-pipes';
import { OrderData } from '@zero/shared/util-models';
import { environment } from 'environments/environment';

import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { OrderItemBase } from '../order-item-base/order-item.component';
import { OrderItemExecTypeComponent } from '../order-item-exec-type/order-item-exec-type.component';
import { OrderProvisionComponent } from '../order-provision/order-provision.component';
import { OrderValueComponent } from '../order-value/order-value.component';

@Component({
  selector: 'tr[app-executed-order-item]',
  templateUrl: './executed-order-item.component.html',
  imports: [
    NgClass,
    InstrumentDetailsLinkComponent,
    WatchlistToggleComponent,
    OrderItemExecTypeComponent,
    RouterLink,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    DisplayLabelPipe,
    OrderStatusPipe,
    OrderIsPartiallyFilledPipe,
    OrderIsStornoPipe_1,
    OrderExecTypePipe,
    ShorthandSymbolPipe,
    OrderValueComponent,
    OrderProvisionComponent,
  ],
})
export class ExecutedOrderItemComponent extends OrderItemBase implements OnChanges {
  public highlighted: boolean;
  public pdfUri: string;

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes['order']?.currentValue && changes['order'].currentValue !== changes['order'].previousValue) {
      this.highlighted = this.showHighlighted(this.order);
      this.pdfUri = this.getPdfUriForOrder(this.order);
    }
  }

  public deleteCachedDocuments(): void {
    this.dataService.deleteCachedDocuments();
  }

  private showHighlighted(order: OrderData): boolean {
    const isStornoPipe = new OrderIsStornoPipe();
    return !isStornoPipe.transform(order) && !order.transactionKey;
  }

  private getPdfUriForOrder(order: OrderData): string {
    if (!order.transactionKey) {
      return '';
    }

    return `${encodeURI(
      `${environment.apihost + environment.posteingangServiceUrl}/${this.dataService.getSelectedCustomer()}/order/${order.id}/Order-${
        order.isin
      }-${order.execDate}`,
    )}.pdf`;
  }
}
